import * as React from 'react'
import moment from 'moment'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { ISelectedEmployeeToCreateHours } from './index'
import { FormError } from '../../../../../../components/FormError'
import { API } from '@getgreenline/homi-shared'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import Datepicker from 'react-datepicker'
import { parseErrorMsg } from '../../../../../../utilities/helpers'
import './CreateEmployeeHourModal.scss'

interface IProps {
  currentCompanyStore?: CurrentCompanyStore

  employee: ISelectedEmployeeToCreateHours
  onSubmit: () => void
  onClose: () => void
}

interface IState {
  startTime: Date
  endTime: Date
  errorMessage: string
  isLoading: boolean
}

@inject('currentCompanyStore')
@observer
export class CreateEmployeeHourModal extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      startTime: new Date(),
      endTime: new Date(),
      errorMessage: '',
      isLoading: false,
    }
  }

  create = async () => {
    const company = this.props.currentCompanyStore!.company!
    const { employee, onSubmit } = this.props
    const { startTime, endTime } = this.state

    this.setState({ isLoading: true })
    try {
      await API.createEmployeeHour(company.id, employee.employeeId, {
        startTime,
        endTime,
        employeeId: employee.employeeId,
      })
      onSubmit()
    } catch (error) {
      this.setState({
        errorMessage: parseErrorMsg(error) || 'There was an error creating employee hours',
        isLoading: false,
      })
    }
  }

  render() {
    const { employee, onSubmit, onClose } = this.props
    const { startTime, endTime, errorMessage, isLoading } = this.state

    return (
      <Modal isOpen={true} toggle={onClose} size='lg' id='create-employee-hour-modal'>
        <ModalHeader toggle={onClose}>Add hours for {employee.employeeName}</ModalHeader>
        <ModalBody>
          <>
            {
              <>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-label'>Start time</label>
                      <div className='text-muted mb-2'>{moment(startTime).format('LLLL')}</div>
                      <Datepicker
                        className='form-control'
                        dateFormat='LLL'
                        timeFormat='hh:mm a'
                        showTimeSelect
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode='select'
                        selected={moment(startTime)}
                        timeIntervals={10}
                        onChange={(date) => {
                          if (date) {
                            this.setState({ startTime: date.startOf('minute').toDate() })
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <label className='form-label'>End time</label>
                      <div className='text-muted mb-2'>{moment(endTime).format('LLLL')}</div>
                      <Datepicker
                        className='form-control'
                        dateFormat='LLL'
                        timeFormat='hh:mm a'
                        showTimeSelect
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode='select'
                        selected={moment(endTime)}
                        timeIntervals={10}
                        onChange={(date) => {
                          if (date) {
                            this.setState({ endTime: date.startOf('minute').toDate() })
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                <br />

                <div className='d-flex' style={{ justifyContent: 'flex-end' }}>
                  <button className='btn btn-light' onClick={this.create} disabled={isLoading}>
                    Add hours
                  </button>
                </div>
                <FormError message={errorMessage} />
              </>
            }
          </>
        </ModalBody>
      </Modal>
    )
  }
}
